export class TagApiModel {
  orderNo: number;

  symbol: string;

  description: string;
}
